export default "__VITE_ASSET__Fga_JNhR__"